var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMonthlyBadgeIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14399 1.64101L1.96588 5.37306C1.36638 5.7352 1 6.38456 1 7.08496V14.2778C1 15.0052 1.39486 15.6752 2.03115 16.0275L8.21094 19.4495C8.82744 19.7909 9.57811 19.7826 10.1869 19.4277L16.0072 16.0352C16.6219 15.6769 17 15.0189 17 14.3073V7.05487C17 6.37082 16.6504 5.73422 16.0732 5.36717L10.2513 1.66521C9.61041 1.2577 8.79404 1.24833 8.14399 1.64101Z",
    fill: "#FFBE00",
    stroke: "#FFBE00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMonthlyBadgeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Monthly_Badge_Icon.6128f259.svg";
export { ForwardRef as ReactComponent };